import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { usersQueryKeys } from 'utils/query-keys'

export interface UserSubscriptionTrackerResponse {
  success: boolean
  error?: string
  linq_blue: {
    present: boolean
    quantity?: number
    product_ids?: string[]
    price_ids?: string[]
  }
  linq_one: {
    present: boolean
    quantity?: number
    product_ids?: string[]
    price_ids?: string[]
  }
  isBlueNumberAvailable?: boolean
  active_linq_blue_numbers?: number
}

const fetchUserSubscriptionTracker = async (userId: string | number) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v3/users/${userId}/subscription_tracker`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json = await response.json()
  return json.data as UserSubscriptionTrackerResponse
}

const useUserSubscriptionTracker = (userId?: string | number) => {
  return useQuery(
    [
      ...usersQueryKeys.detail(userId?.toString() || ''),
      'subscription_tracker',
    ],
    () => fetchUserSubscriptionTracker(userId!),
    {
      enabled: !!userId,
    }
  )
}

export default useUserSubscriptionTracker
